// Sound Effects Utility for Cart Actions
export class SoundEffects {
  constructor() {
    this.notificationAudio = null;
    this.initAudio();
  }

  initAudio() {
    try {
      // Create audio element for playing the music file
      this.notificationAudio = new Audio('/music/notification.mp3');
      this.notificationAudio.volume = 0.5; // Set volume to 50%
      this.notificationAudio.preload = 'auto';
    } catch (error) {
      console.warn('Error initializing audio:', error);
    }
  }

  // Play custom notification sound for add to cart
  playAddToCartSound() {
    if (!this.notificationAudio) {
      this.initAudio();
    }

    if (this.notificationAudio) {
      try {
        // Reset audio to beginning and play
        this.notificationAudio.currentTime = 0;
        this.notificationAudio.play().catch(error => {
          console.warn('Error playing add to cart sound:', error);
        });
      } catch (error) {
        console.warn('Error playing add to cart sound:', error);
      }
    }
  }

  // Play success confirmation sound (silent to avoid double sound)
  playSuccessSound() {
    // Silent - no sound for success to avoid playing twice
    // The add to cart sound already provides the notification
    return;
  }
}

// Create singleton instance
export const soundEffects = new SoundEffects();
